// src/index.ts
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';

// Initialize Alpine plugins
Alpine.plugin(intersect);
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('common', function() {
    return {
      currentVideoId: null as string | null,

      viewedPostIds: [] as string[],

      loadVideo(video: HTMLVideoElement) {
        let needsLoad = false

        for (let i = 0; i < video.children.length; i++) {
          const child = video.children.item(i)
          if (child) {
            const src = child.getAttribute('data-src')
            if (src) {
              if (child.getAttribute('src') !== src) {
                child.setAttribute('src', src)
                needsLoad = true
              }
            }
          }
        }

        if (needsLoad) {
          video.load()
        }
      },

      async handleVideoIntersect(video: HTMLVideoElement, isIntersecting: boolean) {
        const videoId = video.id.replace('video-', '');

        if (isIntersecting) {
          // load the video
          this.loadVideo(video)
          // load next video
          const indexRaw = video.getAttribute('data-video-index')
          if (indexRaw) {
            const index = parseInt(indexRaw)
            const nextVideo = document.querySelector('video[data-video-index="' + (index + 1).toString() + '"]')
            if (nextVideo) {
              this.loadVideo(nextVideo as HTMLVideoElement)
            }
          }

          this.currentVideoId = videoId;

          if (window.umami) {
            // TODO: limit this to once per post per ip address per day/interval
            const post_id = video.getAttribute('data-post-id')
            const creator_id = video.getAttribute('data-creator-id')

            if (post_id && creator_id) {
              const seen = this.viewedPostIds.includes(post_id)
              this.viewedPostIds.push(post_id)

              if (!seen) {
                umami.track('video_view', {
                  post_id,
                  creator_id,
                })
              }
            }
          }

          // Ensure video is muted first for autoplay to work
          video.muted = true;

          try {
            // Reset video position
            video.currentTime = 0;

            // Try to play immediately
            await video.play();

            // Optionally unmute after successful autoplay (if desired)
            // video.muted = false;
          } catch (error) {
            console.warn('Error autoplaying video:', error);

            // Fallback approach - try playing muted
            try {
              video.muted = true;
              await video.play();
            } catch (retryError) {
              console.error('Failed to autoplay even with fallback:', retryError);
            }
          }
        } else {
          if (this.currentVideoId === videoId) {
            this.currentVideoId = null;
          }
          video.pause();
          video.currentTime = 0;
        }
      },

    }
  })

});

Alpine.start();

